var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTbellLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 137.191,
    height: 27.917,
    viewBox: "0 0 137.191 27.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_224",
    "data-name": "\\uC0AC\\uAC01\\uD615 224",
    width: 137.191,
    height: 27.917,
    fill: "current"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b_logo1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_315",
    "data-name": "\\uD328\\uC2A4 315",
    d: "M16.169,4.991V27.917H10.722V4.991H0V0H26.937V4.991Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_316",
    "data-name": "\\uD328\\uC2A4 316",
    d: "M62.029,14.919H61.96v6.916h.069Z",
    transform: "translate(3.427 0.825)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_317",
    "data-name": "\\uD328\\uC2A4 317",
    d: "M62.029,4.5H61.96v6.231h.069Z",
    transform: "translate(3.427 0.249)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_318",
    "data-name": "\\uD328\\uC2A4 318",
    d: "M33.219,0H27.883V27.917h5.336Z",
    transform: "translate(1.542)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_319",
    "data-name": "\\uD328\\uC2A4 319",
    d: "M48.77,13.524a4.675,4.675,0,0,0,2.981-1.493,4.7,4.7,0,0,0,1.039-3.217v-3.4a5.831,5.831,0,0,0-1.237-4.136,5.3,5.3,0,0,0-4-1.282H34.465V4.545H45.279a3.16,3.16,0,0,1,1.96.46,1.938,1.938,0,0,1,.534,1.544V9.191a1.947,1.947,0,0,1-.538,1.558,3.218,3.218,0,0,1-1.96.46H34.465v4.6H45.279a2.962,2.962,0,0,1,2.084.542,2.738,2.738,0,0,1,.543,1.939V20.4a2.756,2.756,0,0,1-.543,1.953,2.947,2.947,0,0,1-2.084.556H34.465v5.009H46.093a8.368,8.368,0,0,0,5.175-1.346,4.928,4.928,0,0,0,1.707-4.136V18.887a5.731,5.731,0,0,0-1.095-3.644A4.68,4.68,0,0,0,48.77,13.524Z",
    transform: "translate(1.906)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_320",
    "data-name": "\\uD328\\uC2A4 320",
    d: "M80.589,21.472H63.551v5.257H80.589Z",
    transform: "translate(3.515 1.188)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_321",
    "data-name": "\\uD328\\uC2A4 321",
    d: "M72.668,10.412H63.551v4.756h9.117Z",
    transform: "translate(3.515 0.576)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_322",
    "data-name": "\\uD328\\uC2A4 322",
    d: "M80.363,0H63.551V4.752H80.363Z",
    transform: "translate(3.515)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_323",
    "data-name": "\\uD328\\uC2A4 323",
    d: "M62.245,22.66V15.744h.069V10.988h-.069V4.752h.069V0H56.808V27.917h5.506V22.66Z",
    transform: "translate(3.142)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_324",
    "data-name": "\\uD328\\uC2A4 324",
    d: "M89.5,22.66V0H84.059V27.917h5.469V22.66Z",
    transform: "translate(4.65)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_325",
    "data-name": "\\uD328\\uC2A4 325",
    d: "M106.663,21.472h-15.9v5.257h15.9Z",
    transform: "translate(5.021 1.188)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_326",
    "data-name": "\\uD328\\uC2A4 326",
    d: "M130.836,21.472H114.888v5.257h15.948Z",
    transform: "translate(6.355 1.188)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_327",
    "data-name": "\\uD328\\uC2A4 327",
    d: "M113.642,0h-5.414V27.917h5.414Z",
    transform: "translate(5.987)",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbellLogo);
export default __webpack_public_path__ + "static/media/tbell-logo.58a23cd8d41c8f3a924b7f6ab2f30c5a.svg";
export { ForwardRef as ReactComponent };